import { render, staticRenderFns } from "./FinishOnboardSection.vue?vue&type=template&id=7cb2a16a&scoped=true"
import script from "./FinishOnboardSection.vue?vue&type=script&lang=js"
export * from "./FinishOnboardSection.vue?vue&type=script&lang=js"
import style0 from "./FinishOnboardSection.vue?vue&type=style&index=0&id=7cb2a16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb2a16a",
  null
  
)

export default component.exports